// import { NavLink } from "react-router-dom";

// const links = [
//   { label: "Profile", path: "/my-account", end: true },
//   { label: "Orders", path: "/my-account/my-orders" },
//   { label: "Address", path: "/my-account/address" },
//   { label: "Wishlist", path: "/my-account/wishlist" },
//   { label: "Coupon", path: "/my-account/coupon" },
//   { label: "Settings", path: "/my-account/settings" },
// ];

// const AccountMenu = () => {
//   return (
//     <div className="bg-white rounded-xl p-4">
//       <div className="flex flex-col gap-2">
//         {links.map((item) => (
//           <NavLink
//             key={item.path}
//             to={item.path}
//             end={item.end}   // ⭐ IMPORTANT
//             className={({ isActive }) =>
//               `w-full px-4 py-3 rounded-lg text-sm font-medium transition ${
//                 isActive
//                   ? "bg-blue-500 text-white"
//                   : "text-gray-700 hover:bg-gray-100"
//               }`
//             }
//           >
//             {item.label}
//           </NavLink>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default AccountMenu;


// import { NavLink } from "react-router-dom";

// const links = [
//   { label: "Profile", path: "/my-account", end: true },
//   { label: "Orders", path: "/my-account/my-orders" },
//   { label: "Address", path: "/my-account/address" },
//   { label: "Wishlist", path: "/my-account/wishlist" },
//   // { label: "Coupon", path: "/my-account/coupon" },
//   // { label: "Settings", path: "/my-account/settings" },
// ];

// const AccountMenu = () => {
//   return (
//     <div
//       className="
//         bg-white rounded-xl p-4
//         sticky top-6
//         overflow-y-auto border border-[#B5CAFF]
//       "
//     >
//       <div className="flex flex-col gap-6 text-center">
//         {links.map((item) => (
//           <NavLink
//             key={item.path}
//             to={item.path}
//             end={item.end}
//             className={({ isActive }) =>
//               `w-full px-4 py-2.5 rounded-md text-sm font-medium transition ${
//                 isActive
//                   ? "bg-[#007BFF] text-white"
//                   : "text-gray-700 hover:bg-gray-100"
//               }`
//             }
//           >
//             {item.label}
//           </NavLink>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default AccountMenu;


import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

const links = [
  { label: "Profile", path: "/my-account", end: true },
  { label: "Orders", path: "/my-account/my-orders" },
  { label: "Address", path: "/my-account/address" },
  { label: "Wishlist", path: "/my-account/wishlist" },
  // { label: "Settings", path: "/my-account/settings" },
];

const AccountMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    const handleResize = () => {
      const isLgScreen = window.innerWidth >= 1024; // Tailwind lg breakpoint

      if (isLgScreen && currentPath !== "/my-account" && currentPath === "/my-account/menu") {
        navigate("/my-account", { replace: true });
      }
    };

    // Run once on mount
    handleResize();

    // Listen to resize
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [navigate, currentPath]);

  return (
    <div
      className="
        bg-white rounded-xl p-4
        sticky top-6
        overflow-y-auto border border-[#B5CAFF]
      "
    >
      <div className="flex flex-col gap-6 text-center">
        {links.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.end}
            className={({ isActive }) =>
              `w-full px-4 py-2.5 rounded-md text-sm font-medium transition ${
                isActive
                  ? "bg-[#007BFF] text-white"
                  : "text-gray-700 hover:bg-gray-100"
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default AccountMenu;
